/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import {
    array, func, object, string,
} from 'prop-types';
import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Carousel from './Partials/Carousel';
import Header from './Partials/Header';
import DynamicPrice from '../GraphqlProductPage/Partials/GraphqlPDPSkus/DynamicPrice';
import { getEnterpriseId } from '../../../../state/ducks/Member/ducks/EnterpriseId/EnterpriseId-Selectors';
import { getActiveABTests } from '../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getUserSubmittedProductFilterZipcode } from '../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles({
    container: {
        '@media screen and (max-width: 768px)': {
            padding: '0 10px',
        },
        '& .MuiDivider-root': {
            maxWidth: '1300px',
            margin: '0 auto',
        },
    },
});

const Product = ({
    data, product, selectVariant, enterpriseId, selectedSku, setSelectedSku, setProductSkuPrices,
    productSkuPrices, selectedVariant, trackEvent,
}) => {
    const classes = useStyles();
    const heading = data?.title || '';
    const subHeading = data?.sub_title || '';
    const displayDescription = data?.display_product_description;
    const variantsDetail = data?.product_variants || {};

    const isZipDynamicPriceEnabled = useSelector(getFeatureFlag('is-zip-dynamic-pricing-enabled'));
    const activeABTests = useSelector(getActiveABTests);
    const userSubmittedProductFilterZipcode = useSelector(getUserSubmittedProductFilterZipcode);

    // declaring Dynamic price call instance
    const dynamicPriceInstance = new DynamicPrice(product?.productSkus, enterpriseId, true, selectedSku?.subscriptionsList?.type?.[0] || product?.productSkus?.[0]?.subscriptionsList?.type?.[0] || '');
    const {
        getPriceRules, getRetailPrice, getSalePrice, getRetailDisplayPrice,
    } = dynamicPriceInstance;

    useEffect(() => {
        const useZipcode = isZipDynamicPriceEnabled && activeABTests.zipDynamicPricing;

        dynamicPriceInstance.call(useZipcode, userSubmittedProductFilterZipcode).then((productPrices) => {
            const priceRules = getPriceRules(selectedSku?.id);
            const copySelectedSku = { ...selectedSku };
            copySelectedSku.priceRules = priceRules;
            setProductSkuPrices(productPrices?.newPrices || []);
            setSelectedSku(copySelectedSku);
        }).catch(() => {
        });
    }, [selectedSku?.id, userSubmittedProductFilterZipcode]);

    let priceDetails = [];
    const dynamicPriceList = (sku) => {
        if (productSkuPrices.length > 0) {
            const skuItemPriceList = (productSkuPrices || []).find((skuItem) => skuItem?.id === sku?.id)?.prices || [];
            const currentPriceList = JSON.parse(JSON.stringify(sku?.prices || []));
            priceDetails = currentPriceList.map((price) => {
            /**
     * Retail price update for standard products by dynamic price API, not updating for subscription products
     */
                if (price.type === 'retail' && skuItemPriceList.length > 0 && getRetailPrice(skuItemPriceList)) {
                    const retailPrice = getRetailPrice(skuItemPriceList);
                    const salePrice =  getSalePrice(skuItemPriceList);
                    // eslint-disable-next-line no-param-reassign
                    price.value = retailPrice;
                    if ((retailPrice  === salePrice) ||  retailPrice > salePrice) {
                        // eslint-disable-next-line no-param-reassign
                        price.value = getRetailDisplayPrice(skuItemPriceList);
                    }
                }

                /**
     * Used to get what would be the retail dynamic price to show as comparison to discounted subscription price
     */
                if (price.type === 'retail' && skuItemPriceList.length > 0 && getRetailDisplayPrice(skuItemPriceList)) {
                // eslint-disable-next-line no-param-reassign
                    price.value = getRetailDisplayPrice(skuItemPriceList);
                }
                /**
     * Sale price update for standard products and subscription products by dynamic price API
     */
                if (price.type === 'sale' && skuItemPriceList.length > 0 && getSalePrice(skuItemPriceList)) {
                // eslint-disable-next-line no-param-reassign
                    price.value = getSalePrice(skuItemPriceList);
                }
                return price;
            });
        }
        return priceDetails;
    };

    return (
        <div className={classes.container}>
            <Header id="1" heading={heading} subHeading={subHeading} />
            <Carousel
                product={product}
                trackEvent={trackEvent}
                selectVariant={selectVariant}
                variantsDetail={variantsDetail}
                selectedVariant={selectedVariant}
                productSkuPrices={productSkuPrices}
                dynamicPriceList={dynamicPriceList}
                displayDescription={displayDescription}
            />
            <Divider />
        </div>
    );
};

Product.propTypes = {
    data: object.isRequired,
    product: object.isRequired,
    selectVariant: func.isRequired,
    enterpriseId: string.isRequired,
    selectedSku: object.isRequired,
    setSelectedSku: func.isRequired,
    setProductSkuPrices: func.isRequired,
    productSkuPrices: array.isRequired,
    selectedVariant: string.isRequired,
    trackEvent: func.isRequired,
};

const mapStateToProps = (state) => ({
    enterpriseId: getEnterpriseId(state),
});

export default connect(mapStateToProps, {})(Product);
